import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { Note } from './types';

import './NoteSection.css';

type NoteSectionProps = {
    data: Note;
};

export function NoteSection({ data }: NoteSectionProps) {
    const [ref, inView] = useInView<HTMLElement>();
    // Split "<title> - <role>" so the role can drop to its own line on mobile.
    const [noteTitle, ...roleParts] = data.eyebrow.split(' - ');
    const role = roleParts.join(' - ');

    return (
        <section
            ref={ref}
            className={`programs-note faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <figure className="programs-note__inner">
                <span className="programs-eyebrow faves-reveal">
                    {noteTitle}
                    {role && <span className="programs-note__eyebrow-role"> - {role}</span>}
                </span>
                <blockquote
                    className="programs-note__quote faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.quote}
                </blockquote>
                <figcaption
                    className="programs-note__author faves-reveal"
                    style={{ '--reveal-delay': '240ms' } as React.CSSProperties}
                >
                    {data.image
                        ? <img className="programs-note__avatar" src={data.image} alt=""
                            aria-hidden="true" loading="lazy" decoding="async" />
                        : <span className="programs-note__avatar" aria-hidden="true" />}
                    <span className="programs-note__name">{data.author}</span>
                    <span className="programs-note__sep" aria-hidden="true">·</span>
                    <span className="programs-note__org">{data.org}</span>
                </figcaption>
            </figure>
        </section>
    );
}
